import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

import { TranslateService } from '@ngx-translate/core';
import { TravelerComponent } from '../traveler/traveler.component';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';

// import { forEach } from '@angular/router/src/utils/collection';
// import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-reg-on-flight',
  templateUrl: './reg-on-flight.component.html',
  styleUrls: ['./reg-on-flight.component.css']
})
export class RegOnFlightComponent implements OnInit {

  public menu_item_id = '119';
  public add_auth;
  public edit_auth;
  public del_auth;

  selectedTab = 0;
  panelOpenState = false;
  disableNextBtn1 = true;
  disableNextBtn2 = true;
  saveClicked = false;

  agentDetail = '';
  traveler_title = '';
  traveler_count = 1;
  revenue_acct_no = '0';

  invoice_model = {
    'table_name': 'invoice', 'invoice_id': '0', 'invoice_no': '', 'invoice_date': '0000-00-00',
    'customer_no': '', 'customer_name': '', 'calc_tax': '0', 'print_tax': '1', 'total': '', 'tax': '0',
    'discount': '0', 'rep_emp_no': '0', 'deliver_date': '0000-00-00', 'payment_date': '0000-00-00',
    'invoice_type': 'flight', 'cond_list_id': '0', 'transport_fee': '0', 'received_by': '', 'is_paid': '0',
    'status': '1', 'cost_center': '0', 'sales_acct': '0', 'acct_number': '0', 'flag': 'new', 'key': 'invoice_id',
    'qutation_no': '', 'tax_acct': '0', 'trans_acct': '0', 'payment_method': '', 'comment': '',
    'meter_reading': '', 'worker': '', 'group_number': '', 'flight_id': '', 'pnr': '', 'pass_count': '',
    'bed_count': '0', 'seat_count': '0', 'agent_acct_number': '0', 'no': '0',
    'year': '', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id,
    'store_id': '0', 'total_no_tax': '0', 'invoice_uuid': ''
  };

  invoice_item_model = {
    'table_name': 'invoice_item', 'invoice_no': '', 'invoice_date': '0000-00-00',
    'sub_item_number': '0', 'sub_item_name': '', 'price': '0', 'unit_id': '0', 'count': '',
    'total_price': '0', 'tax_no': '', 'invoice_item_id': '0', 'tax_amount': '', 'type': 'p',
    'flag': 'new', 'key': 'invoice_item_id', 'discount': '0', 'stock_no': '0', 'store_id': '0',
    'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '', 'revenue_acct_no': '0'
  }

  inv_payment_model = {
    'table_name': 'inv_payment_method', 'invoice_no': '', 'inv_payment_method_id': '0', 'flag': 'new',
    'key': 'inv_payment_method_id', 'payment_type_id': '2', 'acct_number': '', 'amount': ''
  }

  group_model = {
    'table_name': 'trip_group', 'group_id': '0', 'invoice_no': '', 'head_id': '', 'member_id': '',
    'member_head_relation': '', 'is_active': '1', 'group_type': '', 'trip_arrival_date': '', 'trip_depart_date': '',
    'eticket': '', 'ticket_status': '0', 'ticket_count': '0', 'bed_count': '0', 'price': '0', 'room_type_id': '',
    'flag': 'new', 'key': 'group_id', 'comment': ''
  };

  ticket_model = {
    'table_name': 'reg_on_ticket', 'reg_ticket_id': '0', 'invoice_no': '0', 'ticket_type': 'return', 
    'depart_flight_id': '0', 'return_flight_id': '0', 'depart_date': '', 'return_date': '', 
    'from_airport': '0', 'to_airport': '0', 'airline_id': '0', 'adult_count': '0', 'child_count': '0', 
    'infant_count': '0', 'adult_price': '0', 'child_price': '0', 'infant_price': '0', 'adult_discount': '0', 
    'child_discount': '0', 'infant_discount': '0'
  };

  data_model = {
    'flexible_dates': '3', 'depart_date': new Date(), 'return_date': new Date(), 'reserve_type': 'single', 
    'depart_flight': '0', 'return_flight': '0', 'adult_num': '1', 'child_num': '0', 'infant_num': '0', 
    'traveler_type': 'enter', "ticket_num": '0', 'country_id': '0', 'date_of_birth': new Date("01-01-1980"),
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'dob_year': '', 'dob_month': '', 
    'dob_day': '', 'passport_expiry_date': new Date(), 'ped_year': '', 'ped_month': '', 'ped_day': '', 
    'depend_no': '', 'base_date': new Date(this.applicationConstants.business_cycle.start_date), 
    'ext_amount': '0', 'amount_comment': '', 'final_total': '', 'invoice_date': new Date()
  };

  customer_model = {
    'table_name': 'customer', 'customer_id': '0', 'customer_name': '', 'customer_name_en': '', 
    'customer_last_name': '', 'acct_number': '', 'national_id': '0', 'customer_category_id': '0', 
    'tax_no': '', 'city_id': '0', 'address': '', 'mobile': '', 'phone1': '', 'phone2': '', 'fax': '', 
    'email': '', 'represent1': '', 'represent1_mobile': '', 'represent2': '',
    'represent2_mobile': '', 'def_rep_no': '0', 'claim_day': 0, 'comment': '', 'car_type': '',
    'key': 'customer_id', 'flag': 'new', 'car_model': '', 'car_color': '', 'is_account': '1',
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'customer_cr': '',
    'agent_acct_number': ''
  };

  traveler_model = {
    'table_name': 'traveler_info', 'info_id': '0', 'acct_number': '', 'date_of_birth': '', 'gender': 'm',
    'occupation': '', 'passport_no': '', 'passport_issue_date': '', 'passport_issue_location': '',
    'key': 'info_id', 'flag': 'new', 'passport_expiry_date': '', 'smoker': 'false', 'medical_care': 'false',
    'nationality': '', 'passport_type': '', 'passport_attach': '', 'comment': '',
    'reference': ''
  };

  base_model = {
    'table_name': 'acct_base', 'baseline_id': '0', 'base_date': '', 'acct_number': '',
    'main_acct_no': this.applicationConstants.main_acct_config['customer'],
    'acct_type_no': this.applicationConstants.acct_type_config['customer'], 'key': 'baseline_id',
    'flag': 'new', 'baseline_amount': '0', 'comment': ''
  };

  sub_acct_model = {
    'table_name': 'sub_acct', 'sub_acct_id': '0',
    'acct_type_no': this.applicationConstants.acct_type_config['customer'],
    'main_acct_no': this.applicationConstants.main_acct_config['customer'], 'sub_acct_name': '',
    'sub_acct_name_en': '', 'acct_number': '', 'parent_acct': this.applicationConstants.main_acct_config['customer'],
    'acct_level': '1', 'is_leaf': '1', 'is_cc': '1', 'tax_acct': '0', 'emp_no': '0', 'cc_no': '0',
    'key': 'sub_acct_id', 'flag': 'new', 'comment': '', 'auto_set': '0', 'set_type': 'count'
  };

  block_model = {
    'table_name': 'flight_block', 'flight_block_id': '0', 'invoice_no': '', 'agent_no': '', 
    'ticket_type': 'return', 'depart_flight_id': '0', 'return_flight_id': '0', 'block_num': '0', 
    'block_price': '0'
  };

  search_airport = {
    'placeholder': 'اسم المطار', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': 'airport', 'selected_no': 'airport_id',
      'field_list': ['airport_name', 'airport_name_en', 'airport_code']
    }]
  };

  search_traveler = {
    'placeholder': 'رقم المسافر/ اسم المسافر/ رقم الجوال', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
      'join_table': '`traveler_info`',
      'join_condition': " AND (`customer`.`branch_id` = '" + this.data_model['branch_id'] +
        "' OR `customer`.`branch_id` = '0') AND `customer`.`acct_number` = `traveler_info`.`acct_number`"
    }]
  };

  search_agent = {
    'placeholder': 'رقم الوكيل/ اسم الوكيل/ رقم الجوال', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
      'condition': " AND (`customer`.`branch_id` = '" + this.data_model['branch_id'] +
        "' OR `customer`.`branch_id` = '0') AND `customer`.`is_agent` = '1'"
    }]
  };

  private dp = [];
  private dp2 = [];
  displayedColumns = ['choose', 'flight_name', 'flight_date', 'flight_day', 'depart_time', 'arrival_time', 
    'adult_price', 'child_price', 'infant_price', 'available_seat'];

  dataSource = new MatTableDataSource(this.dp);
  dataSource2 = new MatTableDataSource(this.dp2);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  toDelete = [];
  year_list = [];

  month_list = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

  day_list = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
    '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
    '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'];

  countryList = [];
  city = [];
  cityList = [];
  showResult = false;
  selectedDepartFlight = {};
  selectedReturnFlight = {};
  main_trav_info = { 'customer_name': '' };
  agent_info = {};

  cond_list_id = '0';

  entered_traveler_list = [];
  displayedColumns3 = ['customer_name', 'customer_name_en', 'customer_last_name', 'age', 'passport_no', 
    'edit', 'del'];
  dataSource3 = new MatTableDataSource(this.entered_traveler_list);

  selected_traveler_list = [];
  add_depend_list = [];
  displayedColumns4 = ['acct_number', 'customer_name', 'customer_name_en', 'customer_last_name', 'age', 'passport_no', 
    'del'];
  dataSource4 = new MatTableDataSource(this.add_depend_list);

  request_list = [];
  displayedColumns5 = ['customer_name', 'age', 'type', 'total_price'];  // 'depart_price', 'return_price', 
  dataSource5 = new MatTableDataSource(this.request_list);

  displayedColumns6 = ['customer_name', 'block_num', 'total_price'];  // 'depart_price', 'return_price', 
  dataSource6 = new MatTableDataSource(this.request_list);

  addDialogRef: MatDialogRef<TravelerComponent>;

  from_airport_detail = '';
  to_airport_detail = '';
  agentBalance = 0;

  Dep_Date_Msg; Ret_Date_Msg; Date_Msg; 
  Start_Airport_Msg; End_Airport_Msg; Airport_Name;
  Agent_Placeholder; Adult; Child; Infant;
  Hijri_Date_Msg; Main; Traveler_Placeholder;
  Country_Msg; City_Msg; Mobile_Msg; Email_Msg;
  Traveler_Name_Msg; Traveler_Name_En_Msg; Traveler_Last_Name_Msg;
  Date_Of_Birth_Msg; Passport_No_Msg; Passport_Expiry_Date_Msg;
  Infant_Count_Msg; Child_Count_Msg; Adult_Count_Msg;
  Main_Traveler_Msg2; Depend_Msg; From_Airport_Msg;
  To_Airport_Msg; Ticket_Sub_Item; Total_Msg; Total_Msg2;
  Additional_Amount; Trav_Exist_Msg; Traveler_No; Mobile;
  Success_Msg; Error_Msg; Inv_No_Msg;
  Depart_Avail_Seat_Msg; Return_Avail_Seat_Msg;
  Main_Depend_Msg; Depend_Main_Msg;
  Depart_Flight_Msg; Return_Flight_Msg;
  Adult_Count_Msg2; Child_Count_Msg2; Infant_Count_Msg2;
  Block_Sub_Item; Agent_Limit_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService, 
    private route: ActivatedRoute, private router: Router) { 
      this.getMessages(translate);
    }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Dep_Date_Msg').subscribe((res: string) => {
      this.Dep_Date_Msg = res;
    });
    
    translate.get('Ret_Date_Msg').subscribe((res: string) => {
      this.Ret_Date_Msg = res;
    });

    translate.get('Date_Msg').subscribe((res: string) => {
      this.Date_Msg = res;
    });

    translate.get('Start_Airport_Msg').subscribe((res: string) => {
      this.Start_Airport_Msg = res;
    });

    translate.get('End_Airport_Msg').subscribe((res: string) => {
      this.End_Airport_Msg = res;
    });

    translate.get('Airport_Name').subscribe((res: string) => {
      this.Airport_Name = res;
    });
    this.search_airport['placeholder'] = this.Airport_Name;

    translate.get('Agent_Placeholder').subscribe((res: string) => {
      this.Agent_Placeholder = res;
    });
    this.search_agent['placeholder'] = this.Agent_Placeholder;

    translate.get('Adult').subscribe((res: string) => {
      this.Adult = res;
    });

    translate.get('Child').subscribe((res: string) => {
      this.Child = res;
    });

    translate.get('Infant').subscribe((res: string) => {
      this.Infant = res;
    });

    translate.get('Hijri_Date_Msg').subscribe((res: string) => {
      this.Hijri_Date_Msg = res;
    });

    translate.get('Main').subscribe((res: string) => {
      this.Main = res;
    });

    translate.get('Traveler_Placeholder').subscribe((res: string) => {
      this.Traveler_Placeholder = res;
    });
    this.search_traveler['placeholder'] = this.Traveler_Placeholder;
    
    translate.get('Country_Msg').subscribe((res: string) => {
      this.Country_Msg = res;
    });
    
    translate.get('City_Msg').subscribe((res: string) => {
      this.City_Msg = res;
    });
    
    translate.get('Mobile_Msg').subscribe((res: string) => {
      this.Mobile_Msg = res;
    });
    
    translate.get('Email_Msg').subscribe((res: string) => {
      this.Email_Msg = res;
    });
    
    translate.get('Traveler_Name_Msg').subscribe((res: string) => {
      this.Traveler_Name_Msg = res;
    });
    
    translate.get('Traveler_Name_En_Msg').subscribe((res: string) => {
      this.Traveler_Name_En_Msg = res;
    });

    translate.get('Traveler_Last_Name_Msg').subscribe((res: string) => {
      this.Traveler_Last_Name_Msg = res;
    });
    
    translate.get('Date_Of_Birth_Msg').subscribe((res: string) => {
      this.Date_Of_Birth_Msg = res;
    });
    
    translate.get('Passport_No_Msg').subscribe((res: string) => {
      this.Passport_No_Msg = res;
    });
    
    translate.get('Passport_Expiry_Date_Msg').subscribe((res: string) => {
      this.Passport_Expiry_Date_Msg = res;
    });

    translate.get('Infant_Count_Msg').subscribe((res: string) => {
      this.Infant_Count_Msg = res;
    });
    
    translate.get('Child_Count_Msg').subscribe((res: string) => {
      this.Child_Count_Msg = res;
    });
    
    translate.get('Adult_Count_Msg').subscribe((res: string) => {
      this.Adult_Count_Msg = res;
    });
    
    translate.get('Main_Traveler_Msg2').subscribe((res: string) => {
      this.Main_Traveler_Msg2 = res;
    });
    
    translate.get('Depend_Msg').subscribe((res: string) => {
      this.Depend_Msg = res;
    });
    
    translate.get('From_Airport_Msg').subscribe((res: string) => {
      this.From_Airport_Msg = res;
    });
    
    translate.get('To_Airport_Msg').subscribe((res: string) => {
      this.To_Airport_Msg = res;
    });
    
    translate.get('Ticket_Sub_Item').subscribe((res: string) => {
      this.Ticket_Sub_Item = res;
    });
    
    translate.get('Block_Sub_Item').subscribe((res: string) => {
      this.Block_Sub_Item = res;
    });
    
    translate.get('Total_Msg').subscribe((res: string) => {
      this.Total_Msg = res;
    });
    
    translate.get('Total_Msg2').subscribe((res: string) => {
      this.Total_Msg2 = res;
    });
    
    translate.get('Additional_Amount').subscribe((res: string) => {
      this.Additional_Amount = res;
    });
   
    translate.get('Trav_Exist_Msg').subscribe((res: string) => {
      this.Trav_Exist_Msg = res;
    });
    
    translate.get('Traveler_No').subscribe((res: string) => {
      this.Traveler_No = res;
    });
    
    translate.get('Mobile').subscribe((res: string) => {
      this.Mobile = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Inv_No_Msg').subscribe((res: string) => {
      this.Inv_No_Msg = res;
    });
    
    translate.get('Depart_Avail_Seat_Msg').subscribe((res: string) => {
      this.Depart_Avail_Seat_Msg = res;
    });

    translate.get('Return_Avail_Seat_Msg').subscribe((res: string) => {
      this.Return_Avail_Seat_Msg = res;
    });
    
    translate.get('Main_Depend_Msg').subscribe((res: string) => {
      this.Main_Depend_Msg = res;
    });
    
    translate.get('Depend_Main_Msg').subscribe((res: string) => {
      this.Depend_Main_Msg = res;
    });
    
    translate.get('Depart_Flight_Msg').subscribe((res: string) => {
      this.Depart_Flight_Msg = res;
    });
    
    translate.get('Return_Flight_Msg').subscribe((res: string) => {
      this.Return_Flight_Msg = res;
    });
    
    translate.get('Adult_Count_Msg2').subscribe((res: string) => {
      this.Adult_Count_Msg2 = res;
    });
    
    translate.get('Child_Count_Msg2').subscribe((res: string) => {
      this.Child_Count_Msg2 = res;
    });
    
    translate.get('Infant_Count_Msg2').subscribe((res: string) => {
      this.Infant_Count_Msg2 = res;
    });
    
    translate.get('Agent_Limit_Msg').subscribe((res: string) => {
      this.Agent_Limit_Msg = res;
    });

    // translate.get('Flight_list').subscribe((res: string) => {
    //   this.Flight_list = res;
    // });
    // this.model['title'] = this.Flight_list;
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let date = new Date();
    this.data_model['depart_date'] = new Date(date.getFullYear(), date.getMonth(), 1);
    this.data_model['return_date'] = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    let query, obj;

    let parent_acct = this.applicationConstants.main_acct_config['income_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data.data['list']);
        if (data.data['list'].length > 0)
          this.revenue_acct_no = data.data['list'][0]['acct_number'];
      });

    query = "SELECT `cond_list_id` FROM `def_inv_cond_list` WHERE `branch_id` = '" + 
      this.invoice_model['branch_id'] + "' AND `invoice_type_key` = 'normal_credit_invoice'"; // + condition;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.data['list'].length > 0) {
          this.cond_list_id = data.data['list'][0]['cond_list_id'];
          this.invoice_model['cond_list_id'] = this.cond_list_id;
        }
      });

    query = this.queryList.all_country;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.countryList = data.data['list'];
      });

    query = this.queryList.all_city;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city = data.data['list'];
        // if (this.dialog_data != null)
        //   this.getCity();
      });

    let current_year = new Intl.DateTimeFormat('ar-TN-u-ca-islamic', {year : 'numeric'}).format(Date.now()).substring(0, 4);
    this.year_list = this.rangeBetween(Number(current_year) - 120, Number(current_year) + 50);

    this.traveler_title = this.Adult + " (" + this.Main + ") " + this.traveler_count;

    this.route.params.subscribe(params => {
      if (params['no'] != undefined && params['no'] != '') {
        this.invoice_model['invoice_no'] = params['no'];
      this.getRegOnFlight();
      }
    });

    if (this.applicationConstants.user_info['user_id'] == undefined) {
      this.search_traveler['table_list'][0]['join_condition'] += " AND `customer`.`agent_acct_number` = '" + 
        this.applicationConstants.user_info['acct_number'] + "'";

      this.invoice_model['agent_acct_number'] = this.applicationConstants.user_info['acct_number'];

      // get agent balance
      obj = { cmd: 'getAcctBalance', acct_number: this.applicationConstants.user_info['acct_number'], acct_type: 'acct', for_agent: '1' };

      this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.agentBalance = Number(this.applicationConstants.user_info['limit_amount']) - Number(data.status['msg']);
        });
    }
    else 
      this.search_traveler['table_list'][0]['join_condition'] += " AND `customer`.`agent_acct_number` = ''";
  }

  getRegOnFlight() {
    let obj = { cmd: 'getContractDetail', invoice_no: this.invoice_model['invoice_no'] };

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'error') 
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        else if (data.status['type'] == 'success') {
          let result = data.status['msg'][0];

          //------------------------ Invoice ------------------------//
          let invoice_info = result['invoice_info'];
          
          this.invoice_model = {
            'table_name': 'invoice', 'invoice_id': invoice_info['invoice_id'],
            'invoice_no': invoice_info['invoice_no'], 'invoice_date': invoice_info['invoice_date'],
            'customer_no': invoice_info['customer_no'], 'customer_name': invoice_info['customer_name'],
            'calc_tax': invoice_info['calc_tax'], 'print_tax': invoice_info['print_tax'],
            'total': invoice_info['total'], 'tax': invoice_info['tax'],
            'discount': invoice_info['discount'], 'rep_emp_no': invoice_info['rep_emp_no'],
            'deliver_date': invoice_info['deliver_date'], 'payment_date': invoice_info['payment_date'],
            'invoice_type': invoice_info['invoice_type'], 'cond_list_id': invoice_info['cond_list_id'],
            'transport_fee': invoice_info['transport_fee'], 'received_by': invoice_info['received_by'],
            'is_paid': invoice_info['is_paid'], 'status': '1',
            'cost_center': invoice_info['cost_center'], 'sales_acct': invoice_info['sales_acct'],
            'acct_number': invoice_info['acct_number'], 'flag': 'update', 'key': 'invoice_id',
            'qutation_no': invoice_info['qutation_no'], 'tax_acct': invoice_info['tax_acct'],
            'trans_acct': invoice_info['trans_acct'], 'payment_method': invoice_info['payment_method'],
            'comment': invoice_info['comment'], 'meter_reading': invoice_info['meter_reading'],
            'worker': invoice_info['worker'], 'group_number': invoice_info['group_number'],
            'flight_id': invoice_info['flight_id'], 'pnr': invoice_info['pnr'],
            'pass_count': invoice_info['pass_count'], 'bed_count': invoice_info['bed_count'],
            'seat_count': invoice_info['seat_count'], 'agent_acct_number': invoice_info['agent_acct_number'], 
            'branch_id': invoice_info['branch_id'], 'store_id': invoice_info['store_id'], 
            'no': invoice_info['no'], 'year': invoice_info['year'],
            'total_no_tax': invoice_info['total_no_tax'], 'invoice_uuid': invoice_info['invoice_uuid']
          };

          if (invoice_info['cond_list_id'] == '0' && this.cond_list_id != '0') 
            this.invoice_model['cond_list_id'] = this.cond_list_id;
  
          this.data_model['invoice_date'] = new Date(invoice_info['invoice_date']);
          this.data_model['reserve_type'] = (invoice_info['invoice_type'] == 'flight' ? 'single' : 'group');

          //------------------------ Invoice Item ------------------------//
          let invoice_item = result['invoice_item'];
          let total = 0;

          invoice_item.forEach(element => {
            element.flag = 'delete';
            element.table_name = 'invoice_item';
            this.toDelete.push(element);

            if (element.type == 'fa') {
              // this.addition_inv_item = element; ext_amount_no_tax
              this.data_model['ext_amount'] = String(Number(element.price) + Number(element.tax_amount));
              // this.model['ext_amount_no_tax'] = String(Number(element.price));
              this.data_model['amount_comment'] = (element.sub_item_name != null ? element.sub_item_name : '');
            }
          });


          //------------------------ Payment Method ------------------------//
          if (result['payment_method'].length > 0) {
            let inv_payment_method = result['payment_method'][0];
            this.inv_payment_model['inv_payment_method_id'] = inv_payment_method['inv_payment_method_id'];
            this.inv_payment_model['flag'] = 'update';
          }

          //------------------------ Trip Group ------------------------//
          let trip_group = result['trip_group'];
          this.selected_traveler_list = trip_group;

          // calculate the number of adults, childs and infants
          if (this.data_model['reserve_type'] == 'single') {
            
          }


          //------------------------ Reg on Ticket ------------------------//
          let reg_on_ticket = result['reg_on_ticket'];
          if (reg_on_ticket.length > 0) {

            this.ticket_model = {
              'table_name': 'reg_on_ticket', 'reg_ticket_id': reg_on_ticket[0]['reg_ticket_id'], 
              'invoice_no': reg_on_ticket[0]['invoice_no'], 'ticket_type': reg_on_ticket[0]['ticket_type'],
              'depart_flight_id': reg_on_ticket[0]['depart_flight_id'], 
              'return_flight_id': reg_on_ticket[0]['return_flight_id'],  
              'depart_date': reg_on_ticket[0]['depart_date'], 'return_date': reg_on_ticket[0]['return_date'], 
              'from_airport': reg_on_ticket[0]['from_airport'], 'to_airport': reg_on_ticket[0]['to_airport'], 
              'airline_id': reg_on_ticket[0]['airline_id'], 'adult_count': reg_on_ticket[0]['adult_count'], 
              'child_count': reg_on_ticket[0]['child_count'], 'infant_count': reg_on_ticket[0]['infant_count'], 
              'adult_price': reg_on_ticket[0]['adult_price'], 'child_price': reg_on_ticket[0]['child_price'], 
              'infant_price': reg_on_ticket[0]['infant_price'], 'adult_discount': reg_on_ticket[0]['adult_discount'], 
              'child_discount': reg_on_ticket[0]['child_discount'], 'infant_discount': reg_on_ticket[0]['infant_discount']
            };

            this.changeTicketType();
            this.data_model['depart_date'] = new Date(reg_on_ticket[0]['depart_date']);
            if (reg_on_ticket[0]['ticket_type'] == "return")
              this.data_model['return_date'] = new Date(reg_on_ticket[0]['return_date']);

            this.from_airport_detail = reg_on_ticket[0]['from_airport_name'] +
              (reg_on_ticket[0]['from_airport_name_en'] != '' ? " - " + reg_on_ticket[0]['from_airport_name_en'] : '');

            this.to_airport_detail = reg_on_ticket[0]['to_airport_name'] +
              (reg_on_ticket[0]['to_airport_name_en'] != '' ? " - " + reg_on_ticket[0]['to_airport_name_en'] : '');

            let checkFlight = true;
            this.search(checkFlight);
          }
        } 
      });
  }

  changeTicketType() {

    if (this.ticket_model['ticket_type'] == "return") {
      this.displayedColumns5 = ['customer_name', 'age', 'type', 'depart_price', 'return_price', 'total_price'];
      this.displayedColumns6 = ['customer_name', 'block_num', 'depart_price', 'return_price', 'total_price'];
    }
    else {
      this.displayedColumns5 = ['customer_name', 'age', 'type', 'depart_price', 'total_price'];
      this.displayedColumns6 = ['customer_name', 'block_num', 'depart_price', 'total_price'];
    }
  }

  rangeBetween(start, end) {
    var arr = new Array(end - start + 1);
    for (var j = 0; j < arr.length; j++, start++) {
      arr[j] = start;
    }
    return arr;
  }

  convertHijriToGreg(type) {
    if(this.data_model[type + '_day'] == '' || this.data_model[type + '_month'] == '' || 
      this.data_model[type + '_year'] == '') {
      // alert(this.Hijri_Date_Msg);
      return
    }

    let julianDay = ((11 * Number(this.data_model[type + '_year']) + 3) / 30) + 354 * 
      Number(this.data_model[type + '_year']) + 30 * Number(this.data_model[type + '_month']) - 
      ((Number(this.data_model[type + '_month']) - 1) / 2) + Number(this.data_model[type + '_day']) + 
      1948440 - 385;

    let b = 0;
    if (julianDay > 2299160) {
      let a = Math.floor((julianDay - 1867216.25) / 36524.25);
      b = 1 + a - Math.floor(a / 4.0);
    }
    let bb = julianDay + b + 1524;
    let cc = Math.floor((bb - 122.1) / 365.25);
    let dd = Math.floor(365.25 * cc);
    let ee = Math.floor((bb - dd) / 30.6001);
    let day_f = String((bb - dd) - Math.floor(30.6001 * ee));
    let month = String(ee - 1);
    if (ee > 13) {
      cc += 1;
      month = String(ee - 13);
    }
    let year = String(cc - 4716);
    let day = (day_f.split('.'))[0];
    let gregDate = new Date(year + "-" + month + "-" + day);

    if (type == 'dob')
      this.data_model['date_of_birth'] = gregDate;
    else if (type == 'pid')
      this.data_model['passport_issue_date'] = gregDate;
    else if (type == 'ped')
      this.data_model['passport_expiry_date'] = gregDate;
  }

  getCity() {
    this.cityList = [];
    this.city.forEach(element => {
      if (element.country_id == this.data_model['country_id'])
        this.cityList.push(element);
    });
  }

  onChangeFromAirport = function (search_result: object) {
    this.ticket_model['from_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeToAirport = function (search_result: object) {
    this.ticket_model['to_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  search(checkFlight = false) {
    if (this.data_model['depart_date'] == undefined) {
      alert(this.Dep_Date_Msg);
      return;
    }

    if (this.ticket_model['ticket_type'] == 'return' && this.data_model['return_date'] == undefined) {
      alert(this.Ret_Date_Msg);
      return;
    }

    if (this.ticket_model['ticket_type'] == 'return' && this.data_model['return_date'] < this.data_model['depart_date']) {
      alert(this.Date_Msg);
      return;
    }

    if (this.ticket_model['from_airport'] == '0') {
      alert(this.Start_Airport_Msg);
      return;
    }

    if (this.ticket_model['to_airport'] == '0') {
      alert(this.End_Airport_Msg);
      return;
    }

    let obj = { cmd: 'getFlightList', 'ticket_type': this.ticket_model['ticket_type'] };

    if (Number(this.data_model['flexible_dates']) > 0)
      obj['flexible_dates'] = this.data_model['flexible_dates'];

    if (this.data_model['depart_date'] != undefined) 
      obj['depart_date'] = this.data_model['depart_date'].getFullYear() + "-" + 
        (this.data_model['depart_date'].getMonth() + 1) + "-" + this.data_model['depart_date'].getDate();

    if (this.ticket_model['ticket_type'] == 'return' && this.data_model['return_date'] != undefined) 
      obj['return_date'] = this.data_model['return_date'].getFullYear() + "-" + 
        (this.data_model['return_date'].getMonth() + 1) + "-" + this.data_model['return_date'].getDate();

    if (this.ticket_model['from_airport'] != '0')
      obj['start_airport'] = this.ticket_model['from_airport'];

    if (this.ticket_model['to_airport'] != '0')
      obj['end_airport'] = this.ticket_model['to_airport'];

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.showResult = true;
        console.log(data);
        this.dp = [];
        this.dp2 = [];

        this.dp = data.data['list'][0]['depart_list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;

        if (this.ticket_model['ticket_type'] == 'return')
          this.dp2 = data.data['list'][0]['return_list'];

        this.dataSource2 = new MatTableDataSource(this.dp2);
        this.dataSource2.sort = this.sort;

        if (this.applicationConstants.user_info['user_id'] == undefined) {
          this.dp.forEach(element => {
            if (Number(element.available_seat) > 9)
              element.available_seat = "9+";
          });

          this.dp2.forEach(element => {
            if (Number(element.available_seat) > 9)
              element.available_seat = "9+";
          });
        }

        if (checkFlight) {
          console.log(this.ticket_model);

          // select the depart flight
          for (let index = 0; index < this.dp.length; index++) {
            if (this.dp[index]['flight_id'] == this.ticket_model['depart_flight_id']) {
              this.selectedDepartFlight = this.dp[index];
              this.data_model['depart_flight'] = this.ticket_model['depart_flight_id'];
              break;
            }
          }

          // select the return flight if exists
          if (this.ticket_model['return_flight_id'] != '0') {
            for (let index = 0; index < this.dp.length; index++) {
              if (this.dp2[index]['flight_id'] == this.ticket_model['return_flight_id']) {
                this.selectedReturnFlight = this.dp2[index];
                this.data_model['return_flight'] = this.ticket_model['return_flight_id'];
                break;
              }
            }

            this.disableNextBtn1 = false;
          }
          else 
            this.disableNextBtn1 = false;
        }
      });
  }

  selectDepartFlight(flight) {

    // this.data_model['depart_flight'] = flight_id; // (document.getElementById("depart_flight") as HTMLInputElement).value; 
    console.log(this.data_model['depart_flight']);
    this.selectedDepartFlight = flight;

    if (this.disableNextBtn1 && this.ticket_model['ticket_type'] == 'return') {
      //this.data_model['return_flight'] = (document.getElementById("return_flight") as HTMLInputElement).value; 
      console.log(this.data_model['return_flight']);
      this.disableNextBtn1 = (this.data_model['return_flight'] == '0'); 
    }
    else 
      this.disableNextBtn1 = false;

    this.updateTravelerAge();
  }

  selectReturnFlight(flight) {

    // this.data_model['return_flight'] = flight_id; // (document.getElementById("return_flight") as HTMLInputElement).value; 
    console.log(this.data_model['return_flight']);
    this.selectedReturnFlight = flight;

    // this.data_model['depart_flight'] = (document.getElementById("depart_flight") as HTMLInputElement).value; 
    console.log(this.data_model['depart_flight']);

    if (this.disableNextBtn1)
      this.disableNextBtn1 = (this.data_model['depart_flight'] == '0');
    
    this.updateTravelerAge();
  }

  changeTab(event) {
    if (event.index == 2) 
      this.fillRequestList();
  }
 
  next(event) {
    let btnId = event.srcElement.id;

    if (btnId == "btn_next1")
      this.selectedTab = 1;
    else if (btnId == "btn_next2") {
      this.fillRequestList();
      this.selectedTab = 2;
    }
      
    // else if (btnId == "btn_next3")
    //   this.selectedTab = 3;
  }

  back(event) {
    let btnId = event.srcElement.id;

    if (btnId == "btn_back0")
      this.selectedTab = 0;
    else if (btnId == "btn_back1")
      this.selectedTab = 1;
    // else if (btnId == "btn_back2")
    //   this.selectedTab = 2;
  }

  changeTravelNum(event) {
    
    if (event.srcElement.id == 'adult_num') {
      let adultNum = Number(event.srcElement.value);
      if (adultNum <= 0) 
        event.srcElement.value = "1";
    }
    
    // conunt the already added travelers
    let adultCount = 0, childCount = 0, infantCount = 0;

    if (this.data_model['traveler_type'] == 'enter') {
      this.entered_traveler_list.forEach(element => {
        if (element.type == "infant")
          infantCount++;
        else if (element.type == "child")
          childCount++;
        else 
          adultCount++;
      });
    }
    else {
      this.selected_traveler_list.forEach(element => {
        if (element.type == "infant")
          infantCount++;
        else if (element.type == "child")
          childCount++;
        else 
          adultCount++;
      });
    }

    // enable/ disabled next button
    // if ((Number(this.data_model['adult_num']) + Number(this.data_model['child_num'])) > Number(this.selectedDepartFlight['available_seat'])) {
    //   alert(this.Depart_Avail_Seat_Msg);

    //   if (event.srcElement.id == 'adult_num') 
    //     event.srcElement.value = Number(this.selectedDepartFlight['available_seat']) - 
    //       Number((document.getElementById('child_num') as HTMLInputElement).value); // Number(this.data_model['child_num']);
    //   else if (event.srcElement.id == 'child_num') 
    //     event.srcElement.value = Number(this.selectedDepartFlight['available_seat']) - Number((document.getElementById('adult_num') as HTMLInputElement).value); // Number(this.data_model['adult_num']);
    //   // this.disableNextBtn2 = true;
    // }
    // else if (this.ticket_model['ticket_type'] == "return" && 
    //   (Number(this.data_model['adult_num']) + Number(this.data_model['child_num'])) > Number(this.selectedReturnFlight['available_seat'])) {
    //   alert(this.Return_Avail_Seat_Msg);

    //   if (event.srcElement.id == 'adult_num') 
    //     event.srcElement.value = Number(this.selectedReturnFlight['available_seat']) - Number((document.getElementById('child_num') as HTMLInputElement).value); // Number(this.data_model['child_num']);
    //   else if (event.srcElement.id == 'child_num') 
    //     event.srcElement.value = Number(this.selectedReturnFlight['available_seat']) - Number((document.getElementById('adult_num') as HTMLInputElement).value); // Number(this.data_model['adult_num']);
    //   // this.disableNextBtn2 = true;
    // }

    this.disableNextBtn2 = !(adultCount == Number(this.data_model['adult_num']) && 
      childCount == Number(this.data_model['child_num']) && infantCount == Number(this.data_model['infant_num']));
  }

  changeTicketNum() {
    if (Number(this.data_model['ticket_num']) > Number(this.selectedDepartFlight['available_seat'])) {
      alert(this.Depart_Avail_Seat_Msg);
      this.data_model['ticket_num'] = '0';
      this.disableNextBtn2 = true;
    }
    else if (this.ticket_model['ticket_type'] == 'return' && Number(this.data_model['ticket_num']) > Number(this.selectedReturnFlight['available_seat'])) {
      alert(this.Return_Avail_Seat_Msg);
      this.data_model['ticket_num'] = '0';
      this.disableNextBtn2 = true;
    }
    else 
      this.disableNextBtn2 = !(this.agent_info['acct_number'] != undefined && Number(this.data_model['ticket_num']) > 0);
  }

  addTraveler() {
    if (this.data_model['country_id'] == "0") {
      alert(this.Country_Msg);
      return;
    }

    if (this.customer_model['city_id'] == "0") {
      alert(this.City_Msg);
      return;
    }

    if (this.customer_model['mobile'] == "") {
      alert(this.Mobile_Msg);
      return;
    }

    if (this.customer_model['email'] == "") {
      alert(this.Email_Msg);
      return;
    }

    if (this.customer_model['customer_name'] == "") {
      alert(this.Traveler_Name_Msg);
      return;
    }

    if (this.customer_model['customer_name_en'] == "") {
      alert(this.Traveler_Name_En_Msg);
      return;
    }

    if (this.customer_model['customer_last_name'] == "") {
      alert(this.Traveler_Last_Name_Msg);
      return;
    }

    if (this.data_model['date_of_birth'] == undefined) {
      alert(this.Date_Of_Birth_Msg);
      return;
    }
    
    if (this.traveler_model['passport_no'] == "") {
      alert(this.Passport_No_Msg);
      return;
    }

    if (this.data_model['passport_expiry_date'] == undefined) {
      alert(this.Passport_Expiry_Date_Msg);
      return;
    }

    this.traveler_model['date_of_birth'] = (this.data_model['date_of_birth'].getFullYear() + '-' +
      (this.data_model['date_of_birth'].getMonth() + 1) + '-' + this.data_model['date_of_birth'].getDate());

    // calculate traveler age
    let birthdate = this.data_model['date_of_birth'];
    let arrivaldate;

    if (this.ticket_model['ticket_type'] == 'return')
      arrivaldate = new Date(this.selectedReturnFlight['flight_date']);
    else 
      arrivaldate = new Date(this.selectedDepartFlight['flight_date']);
    
    let timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());
    let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
    let type = '', type_name = '';

    let adultCount = 0, childCount = 0, infantCount = 0;

    // conunt the already added travelers
    this.entered_traveler_list.forEach(element => {
      if (element.type == "infant")
        infantCount++;
      else if (element.type == "child")
        childCount++;
      else 
        adultCount++;
    });

    if (age < 2) {
      type = "infant";
      type_name = this.Infant;
      infantCount++;
    }
    else if (age < 12) {
      type = "child";
      type_name = this.Child;
      childCount++;
    }
    else {
      type = 'adult';
      if (adultCount == 0) 
        type_name = this.Adult + " (" + this.Main + ")";
      else 
        type_name = this.Adult;
      adultCount++;
    }

    let travelIndex = this.utils.getDPIndex(this.entered_traveler_list, 'passport_no', this.traveler_model['passport_no']);

    if (travelIndex != -1) {
      this.entered_traveler_list[travelIndex] = { 
        'index':  this.entered_traveler_list[travelIndex]['index'], 'country_id': this.data_model['country_id'], 
        'city_id': this.customer_model['city_id'], 'mobile': this.customer_model['mobile'], 
        'email': this.customer_model['email'], 'customer_name': this.customer_model['customer_name'], 
        'customer_name_en': this.customer_model['customer_name_en'], 'age': age, 'type': type, 
        'type_name': type_name, 'customer_last_name': this.customer_model['customer_last_name'], 
        'dob_year': this.data_model['dob_year'], 
        'dob_month': this.data_model['dob_month'], 'dob_day': this.data_model['dob_day'], 
        'date_of_birth': this.data_model['date_of_birth'], 'gender': this.traveler_model['gender'], 
        'passport_no': this.traveler_model['passport_no'], 'ped_year': this.data_model['ped_year'], 
        'ped_month': this.data_model['ped_month'], 'ped_day': this.data_model['ped_day'], 
        'passport_expiry_date': this.data_model['passport_expiry_date'], 
        'depart_date': this.selectedDepartFlight['flight_date'], 
        'arrival_date': (this.ticket_model['ticket_type'] == 'return' ? this.selectedReturnFlight['flight_date'] : '')
      };

        this.dataSource3 = new MatTableDataSource(this.entered_traveler_list);
        this.dataSource3.sort = this.sort;
    }

    // conunt the already added travelers
    // this.entered_traveler_list.forEach(element => {
    //   if (element.type == "infant")
    //     infantCount++;
    //   else if (element.type == "child")
    //     childCount++;
    //   else 
    //     adultCount++;
    // });

    
    if (travelIndex == -1 && type == "infant" && Number(this.data_model['infant_num']) < infantCount) {
      alert(this.Infant_Count_Msg);
      return;
    }

    else if (travelIndex == -1 && type == "child" && Number(this.data_model['child_num']) < childCount) {
      alert(this.Child_Count_Msg);
      return;
    }

    else if (travelIndex == -1 && type == "adult" && Number(this.data_model['adult_num']) < adultCount) {
      alert(this.Adult_Count_Msg);
      return;
    }

    if (travelIndex == -1) {

      let query = "SELECT `traveler_info`.`acct_number`, `customer`.`mobile` FROM `traveler_info`, `customer` " + 
        "WHERE `traveler_info`.`status` = '1' AND `traveler_info`.`date_of_birth` = '" + 
        this.traveler_model['date_of_birth'] + "' AND `traveler_info`.`passport_no` = '" + 
        this.traveler_model['passport_no'] + "' AND `traveler_info`.`acct_number` = `customer`.`acct_number`";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length == 0) {

            console.log('customer_name_en: ' + this.customer_model['customer_name_en']);
            // add the traveler
            let traveler = { 
              'index': this.entered_traveler_list.length + 1, 'country_id': this.data_model['country_id'], 
              'city_id': this.customer_model['city_id'], 'mobile': this.customer_model['mobile'], 
              'email': this.customer_model['email'], 'customer_name': this.customer_model['customer_name'], 
              'customer_name_en': this.customer_model['customer_name_en'], 'age': age, 'type': type, 'type_name': type_name, 
              'customer_last_name': this.customer_model['customer_last_name'], 'dob_year': this.data_model['dob_year'], 
              'dob_month': this.data_model['dob_month'], 'dob_day': this.data_model['dob_day'], 
              'date_of_birth': this.data_model['date_of_birth'], 'gender': this.traveler_model['gender'], 
              'passport_no': this.traveler_model['passport_no'], 'ped_year': this.data_model['ped_year'], 
              'ped_month': this.data_model['ped_month'], 'ped_day': this.data_model['ped_day'], 
              'passport_expiry_date': this.data_model['passport_expiry_date'],
              'depart_date': this.selectedDepartFlight['flight_date'], 
              'arrival_date': (this.ticket_model['ticket_type'] == 'return' ? this.selectedReturnFlight['flight_date'] : '')
            };

            this.entered_traveler_list.push(traveler);
            this.dataSource3 = new MatTableDataSource(this.entered_traveler_list);
            this.dataSource3.sort = this.sort;

            // change traveler title
            if (adultCount < Number(this.data_model['adult_num'])) {
              if (adultCount == 0)
                this.traveler_title = this.Adult + " (" + this.Main + ") " + (adultCount + 1);
              else 
                this.traveler_title = this.Adult + " " + (adultCount + 1);
            }
            else if (childCount < Number(this.data_model['child_num']))
              this.traveler_title = this.Child + " " + (childCount + 1);
            else if (infantCount < Number(this.data_model['infant_num']))
              this.traveler_title = this.Infant + " " + (infantCount + 1);

            // empty the fields
            this.customer_model['customer_name'] = "";
            this.customer_model['customer_name_en'] = "";
            this.customer_model['customer_last_name'] = "";
            this.data_model['dob_year'] = "";
            this.data_model['dob_month'] = "";
            this.data_model['dob_day'] = "";
            this.data_model['date_of_birth'] = new Date();
            this.traveler_model['gender'] = "m";
            this.traveler_model['passport_no'] = "";
            this.data_model['ped_year'] = "";
            this.data_model['ped_month'] = "";
            this.data_model['ped_day'] = "";
            this.data_model['passport_expiry_date'] = new Date();

            // enable/ disabled next button
            this.disableNextBtn2 = !(adultCount == Number(this.data_model['adult_num']) && 
              childCount == Number(this.data_model['child_num']) && infantCount == Number(this.data_model['infant_num']));
          }
          else {
            let travelerInfo = data.data['list'][0];
            
            alert(this.Trav_Exist_Msg + ", " + this.Traveler_No + ": " + travelerInfo.acct_number + ", " + 
              this.Mobile + ": " + travelerInfo.mobile);
            return;
          }
        });
    }
  
  }

  editEnteredTraveler(row) {

    // fill the fields
    this.customer_model['customer_name'] = row.customer_name;
    this.customer_model['customer_name_en'] = row.customer_name_en;
    this.customer_model['customer_last_name'] = row.customer_last_name;
    this.data_model['dob_year'] = row.dob_year;
    this.data_model['dob_month'] = row.dob_month;
    this.data_model['dob_day'] = row.dob_day;
    this.data_model['date_of_birth'] = new Date(row.date_of_birth);
    this.traveler_model['gender'] = row.gender;
    this.traveler_model['passport_no'] = row.passport_no;
    this.data_model['ped_year'] = row.ped_year;
    this.data_model['ped_month'] = row.ped_month;
    this.data_model['ped_day'] = row.ped_day;
    this.data_model['passport_expiry_date'] = new Date(row.passport_expiry_date);
  }

  delEnteredTraveler(row) {
    let travelIndex = this.utils.getDPIndex(this.entered_traveler_list, 'passport_no', row.passport_no);

    if (travelIndex != -1) {
      this.entered_traveler_list.splice(travelIndex, 1);
      this.dataSource3 = new MatTableDataSource(this.entered_traveler_list);
      this.dataSource3.sort = this.sort;
    }

    let adultCount = 0, childCount = 0, infantCount = 0;
    this.entered_traveler_list.forEach(element => {
        if (element.type == "infant")
          infantCount++;
        else if (element.type == "child")
          childCount++;
        else 
          adultCount++;
      });

    // enable/ disabled next button
    this.disableNextBtn2 = !(adultCount == Number(this.data_model['adult_num']) && 
      childCount == Number(this.data_model['child_num']) && infantCount == Number(this.data_model['infant_num']));
  }

  delSelectedTraveler(row) {
   
    let travelIndex = this.utils.getDPIndex(this.add_depend_list, 'acct_number', row.acct_number);
    
    if (travelIndex != -1) {
      if (this.add_depend_list[travelIndex]['group_id'] != '0') {
        this.add_depend_list[travelIndex]['flag'] = 'delete';
        this.add_depend_list[travelIndex]['table_name'] = 'trip_group';
        this.toDelete.push(this.add_depend_list[travelIndex]);
      }
  
      this.add_depend_list.splice(travelIndex, 1);
      this.dataSource4 = new MatTableDataSource(this.add_depend_list);
      this.dataSource4.sort = this.sort;
    }

    travelIndex = this.utils.getDPIndex(this.selected_traveler_list, 'acct_number', row.acct_number);
    console.log("travelIndex: " + travelIndex);
    if (travelIndex != -1)
      this.selected_traveler_list.splice(travelIndex, 1);

    let adultCount = 0, childCount = 0, infantCount = 0;
    this.selected_traveler_list.forEach(element => {
        if (element.type == "infant")
          infantCount++;
        else if (element.type == "child")
          childCount++;
        else 
          adultCount++;
      });

    // enable/ disabled next button
    this.disableNextBtn2 = !(adultCount == Number(this.data_model['adult_num']) && 
      childCount == Number(this.data_model['child_num']) && infantCount == Number(this.data_model['infant_num']));
  }

  onChangeAgent = function (search_result: object) {

    let old_customer_no = this.invoice_model['customer_no'];

    if (search_result['no'] != '') {

      // let query = "SELECT `customer`.*, `traveler_info`.* FROM `customer`, `traveler_info`" +
      //   " WHERE `customer`.`status` = '1' AND `customer`.`acct_number` = `traveler_info`.`acct_number`" +
      //   " AND `customer`.`acct_number` = '" + search_result['no'] + "'";

      let query = "SELECT `customer`.* FROM `customer` WHERE `customer`.`status` = '1' AND" +
        " `customer`.`acct_number` = '" + search_result['no'] + "'";

      let obj;
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.agent_info = data.data['list'][0];
          this.invoice_model['customer_no'] = search_result['no'];
          this.invoice_model['acct_number'] = search_result['no'];

          if (old_customer_no != '') {
            this.request_list[0]['flag'] = 'delete';
            this.request_list[0]['table_name'] = 'trip_group';
            this.toDelete.push(this.request_list[0]);
          }
          this.changeTicketNum();
        });
    }
    else
      this.changeTicketNum();
  }

  onChangeMainTraveller = function (search_result: object) {

    let old_customer_no = this.invoice_model['customer_no'];
    let adultCount = 0, childCount = 0, infantCount = 0;
    let travelIndex;

    if (search_result['no'] != '') {

      travelIndex = this.utils.getDPIndex(this.add_depend_list, 'acct_number', search_result['no']);

      if (travelIndex != -1) {
        alert(this.Depend_Main_Msg);
        this.main_trav_info = {};
        (document.getElementById('search_value_4') as HTMLInputElement).value = '';
      }
      else {
        let query = "SELECT `customer`.*, `traveler_info`.* FROM `customer`, `traveler_info`" +
          " WHERE `customer`.`status` = '1' AND `customer`.`acct_number` = `traveler_info`.`acct_number`" +
          " AND `customer`.`acct_number` = '" + search_result['no'] + "'";

        let obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            this.main_trav_info = data.data['list'][0];
            let birthdate = new Date(this.main_trav_info['date_of_birth']);
            let arrivaldate;
            if (this.ticket_model['ticket_type'] == 'return')
              arrivaldate = new Date(this.selectedReturnFlight['flight_date']);
            else 
              arrivaldate = new Date(this.selectedDepartFlight['flight_date']);
            
            let timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());
            let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
            this.main_trav_info['age'] = age;

            if (old_customer_no != '') {
              travelIndex = this.utils.getDPIndex(this.selected_traveler_list, 'acct_number', old_customer_no);
              
              if (travelIndex != -1) {
                if (this.selected_traveler_list[travelIndex] != undefined && this.selected_traveler_list[travelIndex]['group_id'] != '0') {
                  this.selected_traveler_list[travelIndex]['flag'] = 'delete';
                  this.selected_traveler_list[travelIndex]['table_name'] = 'trip_group';
                  this.toDelete.push(this.selected_traveler_list[travelIndex]);
                }
          
                this.selected_traveler_list.splice(travelIndex, 1);
              }
            }

            if (age <= 11) {
              this.main_trav_info = {};
              (document.getElementById('search_value_4') as HTMLInputElement).value = '';
              alert(this.Main_Traveler_Msg2);
            }
            else {
              this.main_trav_info['type'] = "adult";
              this.main_trav_info['type_name'] = this.Adult + " (" + this.Main + ")";
              this.invoice_model['customer_no'] = search_result['no'];
              this.invoice_model['acct_number'] = search_result['no'];

              let traveler = { 
                'table_name': 'trip_group', 'group_id': '0', 'flag': 'new', 'key': 'group_id',
                'acct_number': this.main_trav_info['acct_number'], 'customer_name': this.main_trav_info['customer_name'],
                'customer_name_en': this.main_trav_info['customer_name_en'], 'customer_last_name': this.main_trav_info['customer_last_name'],
                'national_id': this.main_trav_info['national_id'], 'mobile': this.main_trav_info['mobile'],
                'passport_no': this.main_trav_info['passport_no'], 'traveler_type': 'تابع', 'comment': '',
                'type': this.main_trav_info['type'], 'type_name': this.main_trav_info['type_name'], 
                'age': age, 'relative_relation': '', 
                'index': this.selected_traveler_list.length, 
                'room_type_id': '', 'date_of_birth': this.main_trav_info['date_of_birth'],
                'depart_date': this.selectedDepartFlight['flight_date'], 
                'arrival_date': (this.ticket_model['ticket_type'] == 'return' ? this.selectedReturnFlight['flight_date'] : '')
              };
              this.selected_traveler_list.unshift(traveler); 
              console.log(this.selected_traveler_list);
            }

            this.selected_traveler_list.forEach(element => {
              if (element.type == "infant")
                infantCount++;
              else if (element.type == "child")
                childCount++;
              else 
                adultCount++;
            });
        
            // enable/ disabled next button
            this.disableNextBtn2 = !(adultCount == Number(this.data_model['adult_num']) && 
              childCount == Number(this.data_model['child_num']) && infantCount == Number(this.data_model['infant_num']));
          });
      }
      
    }
    else if (old_customer_no != '') {
      travelIndex = this.utils.getDPIndex(this.selected_traveler_list, 'acct_number', old_customer_no);
      
      if (travelIndex != -1) {
        if (this.selected_traveler_list[travelIndex] != undefined && this.selected_traveler_list[travelIndex]['group_id'] != '0') {
          this.selected_traveler_list[travelIndex]['flag'] = 'delete';
          this.selected_traveler_list[travelIndex]['table_name'] = 'trip_group';
          this.toDelete.push(this.selected_traveler_list[travelIndex]);
        }
  
        this.selected_traveler_list.splice(travelIndex, 1);
      }

      this.selected_traveler_list.forEach(element => {
        if (element.type == "infant")
          infantCount++;
        else if (element.type == "child")
          childCount++;
        else 
          adultCount++;
      });
  
      // enable/ disabled next button
      this.disableNextBtn2 = !(adultCount == Number(this.data_model['adult_num']) && 
        childCount == Number(this.data_model['child_num']) && infantCount == Number(this.data_model['infant_num']));
    }
 
    // else {
    //   if (old_customer_no != '') {
    //     this.main_trav_info = {};
    //     travelIndex = this.utils.getDPIndex(this.selected_traveler_list, 'acct_number', old_customer_no);

    //     if (this.selected_traveler_list[travelIndex]['group_id'] != '0') {
    //       this.selected_traveler_list[travelIndex]['flag'] = 'delete';
    //       this.selected_traveler_list[travelIndex]['table_name'] = 'trip_group';
    //       this.toDelete.push(this.selected_traveler_list[travelIndex]);
    //     }

    //     this.selected_traveler_list.splice(travelIndex, 1);
    //     // this.adult_count -= 1;
    //     // this.invoice_model['pass_count'] = String(Number(this.model['depend_count']) + 1);
    //   }
    // }
  }

  newTraveler() {
    this.addDialogRef = this.dialog.open(TravelerComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['op_type'] == 'success')
        //   this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
      });
  }

  onChangeDepend = function (search_result: object) {
    this.data_model['depend_no'] = search_result['no'];

    if (this.data_model['depend_no'] != '' && this.data_model['depend_no'] != '0' && 
      this.main_trav_info['acct_number'] != undefined && this.main_trav_info['acct_number'] == this.data_model['depend_no']) {
        
        alert(this.Main_Depend_Msg);
        (document.getElementById('search_value_5') as HTMLInputElement).value = '';
        this.data_model['depend_no'] = '';
    }
  }

  addDepend() {
    if (this.data_model['depend_no'] == '' || this.data_model['depend_no'] == '0') {
      alert(this.Depend_Msg);
      return;
    }

    let adultCount = 0, childCount = 0, infantCount = 0;
    let query = "SELECT `customer`.*, `traveler_info`.* FROM `customer`," +
      " `traveler_info` WHERE `customer`.`status` = '1' AND `customer`.`acct_number` = `traveler_info`.`acct_number`" +
      " AND `customer`.`acct_number` = '" + this.data_model['depend_no'] + "'";

    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => { 
        this.applicationConstants.appComp.hideBusyCursor();
        let depend_info = data.data['list'][0];

        let birthdate = new Date(depend_info['date_of_birth']);
        let arrivaldate;
        if (this.ticket_model['ticket_type'] == 'return')
          arrivaldate = new Date(this.selectedReturnFlight['flight_date']);
        else 
          arrivaldate = new Date(this.selectedDepartFlight['flight_date']);
        
        let timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());
        let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);

        let type = '', type_name = '';
        if (age < 2) {
          type = "infant";
          type_name = this.Infant;
        }
        else if (age < 12) {
          type = "child";
          type_name = this.Child;
        }
        else {
          type = "adult";
          type_name = this.Adult;
        }

        let depend = {
          'table_name': 'trip_group', 'group_id': '0', 'flag': 'new', 'key': 'group_id',
          'acct_number': depend_info['acct_number'], 'customer_name': depend_info['customer_name'],
          'customer_name_en': depend_info['customer_name_en'], 'customer_last_name': depend_info['customer_last_name'],
          'national_id': depend_info['national_id'], 'mobile': depend_info['mobile'],
          'passport_no': depend_info['passport_no'], 'traveler_type': 'تابع', 'comment': this.group_model['comment'],
          'type': type, 'type_name': type_name, 'age': age, 'relative_relation': '', 'index': this.add_depend_list.length,
          'room_type_id': '', 'date_of_birth': depend_info['date_of_birth'],
          'depart_date': this.selectedDepartFlight['flight_date'], 
          'arrival_date': (this.ticket_model['ticket_type'] == 'return' ? this.selectedReturnFlight['flight_date'] : '')
        };

        this.add_depend_list.push(depend);
        this.selected_traveler_list.push(depend);
        this.dataSource4 = new MatTableDataSource(this.add_depend_list);
        this.dataSource4.sort = this.sort;

        (document.getElementById('search_value_5') as HTMLInputElement).value = '';
        
        this.selected_traveler_list.forEach(element => {
          if (element.type == "infant")
            infantCount++;
          else if (element.type == "child")
            childCount++;
          else 
            adultCount++;
        });

        // enable/ disabled next button
        this.disableNextBtn2 = !(adultCount == Number(this.data_model['adult_num']) && 
          childCount == Number(this.data_model['child_num']) && infantCount == Number(this.data_model['infant_num']));

      });
  }

  updateTravelerAge() {
    let birthdate, arrivaldate, timeDiff;
    if (this.data_model['traveler_type'] == 'enter') {

      this.entered_traveler_list.forEach(element => {

        birthdate = new Date(element.date_of_birth);
        if (this.ticket_model['ticket_type'] == 'return')
          arrivaldate = new Date(this.selectedReturnFlight['flight_date']);
        else 
          arrivaldate = new Date(this.selectedDepartFlight['flight_date']);
        
        timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());
        element.age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);

        if (element.age < 2) {
          element.type = "infant";
          element.type_name = this.Infant;
        }
        else if (element.age < 12) {
          element.type = "child";
          element.type_name = this.Child;
        }
        else {
          element.type = "adult";
          element.type_name = this.Adult;
        }
      });
    }
    else {

      this.selected_traveler_list.forEach(element => {
        
        birthdate = new Date(element.date_of_birth);
        if (this.ticket_model['ticket_type'] == 'return')
          arrivaldate = new Date(this.selectedReturnFlight['flight_date']);
        else 
          arrivaldate = new Date(this.selectedDepartFlight['flight_date']);
        
        timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());
        element.age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);

        if (element.age < 2) {
          element.type = "infant";
          element.type_name = this.Infant;
        }
        else if (element.age < 12) {
          element.type = "child";
          element.type_name = this.Child;
        }
        else {
          element.type = "adult";
          element.type_name = this.Adult;
        }

      });
    }
  }

  fillRequestList() {
    let price = 0, total = 0;
    this.request_list = [];
    
    if (this.data_model['reserve_type'] == 'single') {

      if (this.data_model['traveler_type'] == 'enter') {

        this.entered_traveler_list.forEach(element => {
          if (element.type == "infant") {
            price = Number(this.selectedDepartFlight['infant_price']);
            element.depart_price = price.toFixed(2);
            element.return_price = 0;
  
            if (this.ticket_model['ticket_type'] == 'return') {
              element.return_price = ((Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectReturnFlight['infant_price'])).toFixed(2);
              price += (Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectReturnFlight['infant_price']);
            }
          }
          else if (element.type == "child") {
            price = Number(this.selectedDepartFlight['child_price']);
            element.depart_price = price.toFixed(2);
            element.return_price = 0;
  
            if (this.ticket_model['ticket_type'] == 'return') {
              element.return_price = ((Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['child_price'])).toFixed(2);
              price += (Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['child_price']);
            }
          }
          else {
            price = Number(this.selectedDepartFlight['adult_price']);
            element.depart_price = price.toFixed(2);
            element.return_price = 0;
  
            if (this.ticket_model['ticket_type'] == 'return') {
              element.return_price = ((Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['adult_price'])).toFixed(2);
              price += (Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['adult_price']);
            }
          }
          element.total_price = price.toFixed(2);
          total += price;
          this.request_list.push(element);
        });
    
      }
      else {
  
        this.selected_traveler_list.forEach(element => {
          if (element.type == "infant") {
            price = Number(this.selectedDepartFlight['infant_price']);
            element.depart_price = price.toFixed(2);
            element.return_price = 0;
  
            if (this.ticket_model['ticket_type'] == 'return') {
              element.return_price = ((Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['infant_price'])).toFixed(2);
              price += (Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['infant_price']);
            }
          }
          else if (element.type == "child") {
            price = Number(this.selectedDepartFlight['child_price']);
            element.depart_price = price.toFixed(2);
            element.return_price = 0;
  
            if (this.ticket_model['ticket_type'] == 'return') {
              element.return_price = ((Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['child_price'])).toFixed(2);
              price += (Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['child_price']);
            }
          }
          else {
            price = Number(this.selectedDepartFlight['adult_price']);
            element.depart_price = price.toFixed(2);
            element.return_price = 0;
  
            if (this.ticket_model['ticket_type'] == 'return') {
              element.return_price = ((Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['adult_price'])).toFixed(2);
              price += (Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['adult_price']);
            } 
          }
          element.total_price = price.toFixed(2);
          total += price;
          this.request_list.push(element);
        });
      }

      this.dataSource5 = new MatTableDataSource(this.request_list);
      this.dataSource5.sort = this.sort;
    }
    else {
      this.agent_info['block_num'] = this.data_model['ticket_num'];
      price = Number(this.selectedDepartFlight['adult_group_price']);
      this.agent_info['depart_price'] = price.toFixed(2);

      if (this.ticket_model['ticket_type'] == 'return') {
        this.agent_info['return_price'] = ((Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['adult_group_price'])).toFixed(2);
        price += (Number(this.selectedDepartFlight['return_perc']) / 100) * Number(this.selectedReturnFlight['adult_group_price']);
      }

      this.agent_info['block_price'] = price.toFixed(2);
      price = (price * Number(this.data_model['ticket_num']))
      this.agent_info['total_price'] = price.toFixed(2);
      total += price;
      this.request_list.push(this.agent_info);

      this.dataSource6 = new MatTableDataSource(this.request_list);
      this.dataSource6.sort = this.sort;
    }

    this.invoice_model['total'] = total.toFixed(2);
    this.data_model['final_total'] = "";
  }

  resetTotal() {
    this.data_model['final_total'] = "";
  }

  calcTotalAmount() {
    let total = Number(this.invoice_model['total']);
    let discount = Number(this.invoice_model['discount']);
    let ext_amount = Number(this.data_model['ext_amount']);
    
    this.data_model['final_total'] = (total - discount + ext_amount).toFixed(2);
  }

  add() {
    this.saveClicked = true;

    if (this.ticket_model['from_airport'] == '0') {
      alert(this.From_Airport_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.ticket_model['to_airport'] == '0') {
      alert(this.To_Airport_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.data_model['depart_date'] == undefined) {
      alert(this.Dep_Date_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.ticket_model['ticket_type'] == 'return' && this.data_model['return_date'] == undefined) {
      alert(this.Ret_Date_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.selectedDepartFlight['flight_id'] == undefined) {
      alert(this.Depart_Flight_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.ticket_model['ticket_type'] == 'return' && this.selectedReturnFlight['flight_id'] == undefined) {
      alert(this.Return_Flight_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.data_model['reserve_type'] == 'single' && 
      (Number(this.data_model['adult_num']) + Number(this.data_model['child_num'])) > Number(this.selectedDepartFlight['available_seat'])) {
        
        alert(this.Depart_Avail_Seat_Msg);
        this.saveClicked = false;
        return;
    }

    if (this.data_model['reserve_type'] == 'single' && this.ticket_model['ticket_type'] == 'return' && 
      (Number(this.data_model['adult_num']) + Number(this.data_model['child_num'])) > Number(this.selectedReturnFlight['available_seat'])) {

        alert(this.Return_Avail_Seat_Msg);
        this.saveClicked = false;
        return;
    }

    if (this.data_model['reserve_type'] == 'single' && this.applicationConstants.user_info['user_id'] == undefined && 
      (this.agentBalance < 0 || this.agentBalance < Number(this.inv_payment_model['amount']))) {

        alert(this.Agent_Limit_Msg);
        this.saveClicked = false;
        return;
    }

    // count the number of adult and child
    let adultCount = 0, childCount = 0, infantCount = 0; 
    if (this.data_model['reserve_type'] == 'single') {
      if (this.data_model['traveler_type'] == 'enter') {
        this.entered_traveler_list.forEach(element => {
          if (element.type == "infant")
            infantCount++;
          else if (element.type == "child")
            childCount++;
          else 
            adultCount++;
        });
      }
      else {
        this.selected_traveler_list.forEach(element => {
          if (element.type == "infant")
            infantCount++;
          else if (element.type == "child")
            childCount++;
          else 
            adultCount++;
        });
      }
    }
    
    if (this.data_model['reserve_type'] == 'single' && adultCount != Number(this.data_model['adult_num'])) {
      alert(this.Adult_Count_Msg2);
      this.saveClicked = false;
      return;
    }

    if (this.data_model['reserve_type'] == 'single' && childCount != Number(this.data_model['child_num'])) {
      alert(this.Child_Count_Msg2);
      this.saveClicked = false;
      return;
    }

    if (this.data_model['reserve_type'] == 'single' && infantCount != Number(this.data_model['infant_num'])) {
      alert(this.Infant_Count_Msg2);
      this.saveClicked = false;
      return;
    }

    if (this.data_model['reserve_type'] == 'group' && Number(this.data_model['ticket_num']) > Number(this.selectedDepartFlight['available_seat'])) {
      alert(this.Depart_Avail_Seat_Msg);
      this.saveClicked = false;
      return;
    }
    
    if (this.data_model['reserve_type'] == 'group' && this.ticket_model['ticket_type'] == 'return' && 
      Number(this.data_model['ticket_num']) > Number(this.selectedReturnFlight['available_seat'])) {
      alert(this.Return_Avail_Seat_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.data_model['final_total'] == '') {
      alert(this.Total_Msg);
      this.saveClicked = false;
      return;
    }

    if (Number(this.data_model['final_total']) < 0) {
      alert(this.Total_Msg2);
      this.saveClicked = false;
      return;
    }

    // let values = [];
    let obj;

    // if new travelers then save them first
    if (this.data_model['reserve_type'] == 'single') {
      if (this.data_model['traveler_type'] == 'enter') 
        this.checkEnteredTraveler();
      else 
        this.saveInvoice(this.main_trav_info, this.add_depend_list);
    }
    else {
      // get agent limit and balance
      obj = { cmd: 'getAcctBalance', acct_number: this.request_list[0]['acct_number'], acct_type: 'acct' };

      this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          let agentBalance = Number(this.request_list[0]['limit_amount']) - Number(data.status['msg']);
          let total = Number(this.invoice_model['total']) + Number(this.data_model['ext_amount']) - Number(this.invoice_model['discount']);
          // alert(agentBalance);

          if (agentBalance > 0 && agentBalance >= total) 
            this.saveAgentInvoice();
          else {
            alert(this.Agent_Limit_Msg);
            this.saveClicked = false;
          }
        });
    }
  }

  checkEnteredTraveler() {
    let query, obj;
    let alertMsg = "";
    let count = 0;

    // check to make sure that all the travelers are not registerd before
    this.entered_traveler_list.forEach(element => {

      this.traveler_model['date_of_birth'] = (element['date_of_birth'].getFullYear() + '-' +
        (element['date_of_birth'].getMonth() + 1) + '-' + element['date_of_birth'].getDate());

        query = "SELECT `traveler_info`.`acct_number`, `customer`.`mobile` FROM `traveler_info`, `customer` " + 
          "WHERE `traveler_info`.`status` = '1' AND `traveler_info`.`date_of_birth` = '" + 
          this.traveler_model['date_of_birth'] + "' AND `traveler_info`.`passport_no` = '" + 
          element['passport_no'] + "' AND `traveler_info`.`acct_number` = `customer`.`acct_number`";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            count++;
            if (data.data['list'].length != 0) {
              let travelerInfo = data.data['list'][0];

              if (alertMsg != "")
                alertMsg + " ";

              alertMsg += this.Trav_Exist_Msg + ", " + this.Traveler_No + ": " + travelerInfo.acct_number + ", " + 
                this.Mobile + ": " + travelerInfo.mobile + ".";
            }

            if (count == this.entered_traveler_list.length) {
              if (alertMsg == "") 
                this.saveEnteredTraveler();
              else 
                alert(alertMsg);
            }
          });
    });
  }

  saveEnteredTraveler() {
    let query, obj;
    let dependList = [];
    let mainTraveler = {};
    let adultIndex = 0, dependIndex = 0;
    this.entered_traveler_list.forEach(element => {
      if (adultIndex == 0 && element.type == "adult") {
        mainTraveler = element;
        adultIndex++;
      }
      else
        dependList.push(element);
    });

    // generate acct number for traveler
    query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" +
      this.sub_acct_model['parent_acct'] + "'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        let result = data.data['list'][0]['acct_number'];
        if (result != '0') {
          if (result.indexOf(this.sub_acct_model['parent_acct']) != -1)
            result = result.substring(result.indexOf(this.sub_acct_model['parent_acct']) + (this.sub_acct_model['parent_acct']).length);
        }

        console.log('result: ' + result);
        let count = 1;

        // add the main traveler
        result = String(Number(result) + 1);
        if (Number(result) < 10)
          result = '00' + result;
        else if (Number(result) < 100)
          result = '0' + result;

        let values = [];

        // customer data
        this.customer_model['acct_number'] = this.sub_acct_model['parent_acct'] + result;
        this.customer_model['customer_name'] = mainTraveler['customer_name'];
        this.customer_model['customer_name_en'] = mainTraveler['customer_name_en'];
        this.customer_model['customer_last_name'] = mainTraveler['customer_last_name'];
        this.customer_model['national_id'] = mainTraveler['passport_no'];
        this.customer_model['city_id'] = mainTraveler['city_id'];
        this.customer_model['mobile'] = mainTraveler['mobile'];
        this.customer_model['email'] = mainTraveler['email'];
        if (this.applicationConstants.user_info['user_id'] == undefined)
          this.customer_model['agent_acct_number'] = this.applicationConstants.user_info['acct_number'];
        else 
          this.customer_model['agent_acct_number'] = "";
        values.push(this.customer_model);
        
        // traveler data
        this.traveler_model['acct_number'] = this.customer_model['acct_number'];
        this.traveler_model['date_of_birth'] = (mainTraveler['date_of_birth'].getFullYear() + '-' +
          (mainTraveler['date_of_birth'].getMonth() + 1) + '-' + mainTraveler['date_of_birth'].getDate());
        
        this.traveler_model['gender'] = mainTraveler['gender'];
        this.traveler_model['passport_no'] = mainTraveler['passport_no'];
        this.traveler_model['passport_issue_date'] = (new Date().getFullYear() + '-' +
          (new Date().getMonth() + 1) + '-' + new Date().getDate());
    
        this.traveler_model['passport_expiry_date'] = (mainTraveler['passport_expiry_date'].getFullYear() + '-' +
          (mainTraveler['passport_expiry_date'].getMonth() + 1) + '-' + mainTraveler['passport_expiry_date'].getDate());
        this.traveler_model['nationality'] = mainTraveler['country_id'];
        values.push(this.traveler_model);

        // sub acct data
        this.sub_acct_model['sub_acct_name'] = this.customer_model['customer_name'];
        this.sub_acct_model['sub_acct_name_en'] = this.customer_model['customer_name_en'] + " " + 
          this.customer_model['customer_last_name'];
        this.sub_acct_model['acct_number'] = this.customer_model['acct_number'];

        values.push(this.sub_acct_model);

        //add acct base
        this.base_model['base_date'] = this.data_model['base_date'].getFullYear() + '-' +
        (this.data_model['base_date'].getMonth() + 1) + '-' + this.data_model['base_date'].getDate() +
        " 00:00:00";
        // this.data_model['base_date'].getFullYear() + '-01-01 00:00:00';
        this.base_model['acct_number'] = this.customer_model['acct_number'];
        values.push(this.base_model);

        obj = { cmd: 'add', values: values };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            if (data.status['type'] == 'success') {
              this.invoice_model['customer_no'] = this.customer_model['acct_number'];
              this.invoice_model['acct_number'] = this.customer_model['acct_number'];
              mainTraveler['acct_number'] = this.customer_model['acct_number'];

              values = [];

              // add dependent
              if (dependList.length > 0) {
                dependList.forEach(element => {
                  count++;
                  result = String(Number(result) + 1);
                  if (Number(result) < 10)
                    result = '00' + result;
                  else if (Number(result) < 100)
                    result = '0' + result;
  
                  element.acct_number = this.sub_acct_model['parent_acct'] + result;
  
                  // customer data
                  values.push({
                    'table_name': 'customer', 'customer_id': '0', 'customer_name': element.customer_name, 
                    'customer_name_en': element.customer_name_en, 'customer_last_name': element.customer_last_name, 
                    'acct_number': element.acct_number, 'national_id': element.passport_no, 
                    'customer_category_id': '0', 'tax_no': '', 'city_id': element.city_id, 'address': '', 
                    'mobile': element.mobile, 'phone1': '', 'phone2': '', 'fax': '', 
                    'email': element.email, 'represent1': '', 'represent1_mobile': '', 'represent2': '',
                    'represent2_mobile': '', 'def_rep_no': '0', 'claim_day': 0, 'comment': '', 'car_type': '',
                    'key': 'customer_id', 'flag': 'new', 'car_model': '', 'car_color': '', 'is_account': '1',
                    'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'customer_cr': ''
                  });
  
                  // traveler data
                  values.push({
                    'table_name': 'traveler_info', 'info_id': '0', 'acct_number': element.acct_number, 
                    'date_of_birth': (element['date_of_birth'].getFullYear() + '-' +
                    (element['date_of_birth'].getMonth() + 1) + '-' + element['date_of_birth'].getDate()), 
                    'gender': element.gender, 'occupation': '', 'passport_no':  element.passport_no, 
                    'passport_issue_date':  (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + 
                    '-' + new Date().getDate()), 'passport_issue_location': '', 'key': 'info_id', 'flag': 'new', 
                    'passport_expiry_date': (element.passport_expiry_date.getFullYear() + '-' +
                    (element.passport_expiry_date.getMonth() + 1) + '-' + element.passport_expiry_date.getDate()), 
                    'smoker': 'false', 'medical_care': 'false', 'nationality': element.country_id, 
                    'passport_type': '', 'passport_attach': '', 'comment': '', 'reference': ''
                  });
  
                  // sub acct data
                  values.push({
                    'table_name': 'sub_acct', 'sub_acct_id': '0', 'sub_acct_name': element.customer_name,
                    'acct_type_no': this.applicationConstants.acct_type_config['customer'],
                    'main_acct_no': this.applicationConstants.main_acct_config['customer'], 
                    'sub_acct_name_en': element.customer_name_en + " " + element.customer_last_name, 
                    'acct_number': element.acct_number, 'parent_acct': this.applicationConstants.main_acct_config['customer'],
                    'acct_level': '1', 'is_leaf': '1', 'is_cc': '1', 'tax_acct': '0', 'emp_no': '0', 'cc_no': '0',
                    'key': 'sub_acct_id', 'flag': 'new', 'comment': '', 'auto_set': '0', 'set_type': 'count'
                  });
  
                  //add acct base
                  values.push({
                    'table_name': 'acct_base', 'baseline_id': '0', 
                    'base_date': this.data_model['base_date'].getFullYear() + '-' +
                    (this.data_model['base_date'].getMonth() + 1) + '-' + this.data_model['base_date'].getDate() +
                    " 00:00:00", 'acct_number': element.acct_number,
                    'main_acct_no': this.applicationConstants.main_acct_config['customer'],
                    'acct_type_no': this.applicationConstants.acct_type_config['customer'], 'key': 'baseline_id',
                    'flag': 'new', 'baseline_amount': '0', 'comment': ''
                  });
  
                  if (count == this.entered_traveler_list.length) {
                    obj = { cmd: 'add', values: values };
  
                    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                      .subscribe(data => {
                        this.applicationConstants.appComp.hideBusyCursor();
  
                        if (data.status['type'] == 'success') {
                            this.saveInvoice(mainTraveler, dependList);
                        }
                        else {
                          alert(this.Error_Msg);
                          this.saveClicked = false;
                        }
                      });
                  }
                });
              }
              else 
                this.saveInvoice(mainTraveler, dependList);
            }
            else {
              alert(this.Error_Msg);
              this.saveClicked = false;
            }
          });
      });
  }

  saveInvoice(mainTraveler, dependList) {
    let values = [];
    
    if (this.invoice_model['invoice_id'] == '0') {
      let invoice_uuid = uuidv4();
      this.invoice_model['invoice_uuid'] = invoice_uuid;

      let invoice_date = this.data_model['invoice_date'].getFullYear() + "-" + (this.data_model['invoice_date'].getMonth() + 1) + "-" +
        this.data_model['invoice_date'].getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' +
        new Date().getSeconds();

      this.invoice_model['invoice_date'] = invoice_date;
      this.invoice_model['deliver_date'] = invoice_date;
      this.invoice_model['payment_date'] = invoice_date;
    }

    this.invoice_model['payment_method'] = 'credit';
    this.invoice_model['sales_acct'] = this.revenue_acct_no;
    this.invoice_model['total'] =(Number(this.invoice_model['total']) + Number(this.data_model['ext_amount'])).toFixed(2);
    // this.invoice_model['discount'] = this.model['total_discount'];
    this.invoice_model['tax'] = '0';
    this.invoice_model['total_no_tax'] = '0';
    this.invoice_model['pass_count'] = dependList.length + 1;
    this.invoice_model['flight_id'] = this.selectedDepartFlight['flight_id'];
    this.invoice_model['cost_center'] = this.selectedDepartFlight['cost_center'];

    values.push(this.invoice_model);

    //------------------------ Invoice Item ------------------------//
    let item_discount = 0;
    let adultCount = 0, childCount = 0, infantCount = 0;
    let adult_price, child_price, infant_price;
    let discount = Number(this.invoice_model['discount']);

    this.request_list.forEach(element => {

      item_discount = 0;
      if (discount > 0) {
        if (Number(element.total_price) >= discount)
          item_discount = discount;
        else 
          item_discount = Number(element.total_price);

        discount -= item_discount;
      }
      
      values.push({
        'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
        'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
        'sub_item_name': this.Ticket_Sub_Item + " (" + element.type_name + ") - " + element.customer_name_en + " " + element.customer_last_name,
        'price': element.total_price, 'unit_id': '0', 'count': '1',
        'total_price': element.total_price, 'tax_no': "0", 'invoice_item_id': '0', 'tax_amount': '0',
        'type': 'f', 'flag': 'new', 'key': 'invoice_item_id',
        'discount': item_discount, 'stock_no': '0', 'store_id': this.invoice_model['store_id'],
        'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '',
        'revenue_acct_no': this.revenue_acct_no
      });

      if (element.type == "infant") {
        infantCount++;
        infant_price = element.total_price;
      }
      else if (element.type == "child") {
        childCount++;
        child_price = element.total_price;
      }
      else {
        adultCount++;
        adult_price = element.total_price;
      }
        

      if (this.data_model['traveler_type'] == 'select') {
        if (element.acct_number == mainTraveler.acct_number) {
          values.push({
            'table_name': 'trip_group', 'group_id': element.group_id, 'invoice_no': this.invoice_model['invoice_no'],
            'head_id': mainTraveler['acct_number'], 'member_id': mainTraveler['acct_number'],
            'member_head_relation': 'رئيس المجموعة', 'is_active': '1', 'group_type': '',
            'trip_depart_date': element.depart_date, 'member_age': element.age, 'eticket': '',
            'ticket_status': '0', 'ticket_count': '1', 'bed_count': '0',
            'price': element.total_price, 'flag': element.flag, 'key': 'group_id', 'room_type_id': '0', 'comment': '',
            'visa_price': '0', 'food_price': '0'
          });

          if (element.arrival_date != '')
            values[values.length -1]['trip_arrival_date'] = element.arrival_date;
        }
        else {
          values.push({
            'table_name': 'trip_group', 'group_id': element.group_id, 'invoice_no': this.invoice_model['invoice_no'],
            'head_id': mainTraveler['acct_number'], 'member_id': element.acct_number,
            'member_head_relation': '', 'is_active': '1', 'group_type': '',
            'trip_depart_date': element.depart_date, 'member_age': element.age, 'eticket': '',
            'ticket_status': '0', 'ticket_count': '1', 'bed_count': '0',
            'price': element.total_price, 'flag': element.flag, 'key': 'group_id', 'room_type_id': '0', 'comment': '',
            'visa_price': '0', 'food_price': '0'
          });

          if (element.arrival_date != '')
            values[values.length -1]['trip_arrival_date'] = element.arrival_date;
        }
      } 
      else {
        if (element.passport_no == mainTraveler.passport_no) {
          values.push({
            'table_name': 'trip_group', 'group_id': element.group_id, 'invoice_no': this.invoice_model['invoice_no'],
            'head_id': mainTraveler['acct_number'], 'member_id': mainTraveler['acct_number'],
            'member_head_relation': 'رئيس المجموعة', 'is_active': '1', 'group_type': '',
            'trip_depart_date': element.depart_date, 'member_age': element.age, 'eticket': '',
            'ticket_status': '0', 'ticket_count': '1', 'bed_count': '0',
            'price': element.total_price, 'flag': element.flag, 'key': 'group_id', 'room_type_id': '0', 'comment': '',
            'visa_price': '0', 'food_price': '0'
          });

          if (element.arrival_date != '')
            values[values.length -1]['trip_arrival_date'] = element.arrival_date;
        }
        else {
          for (let index = 0; index < dependList.length; index++) {
            if (element.passport_no == dependList[index]['passport_no']) {
              values.push({
                'table_name': 'trip_group', 'group_id': element.group_id, 'invoice_no': this.invoice_model['invoice_no'],
                'head_id': mainTraveler['acct_number'], 'member_id': element.acct_number,
                'member_head_relation': '', 'is_active': '1', 'group_type': '',
                'trip_depart_date': element.depart_date, 'member_age': element.age, 'eticket': '',
                'ticket_status': '0', 'ticket_count': '1', 'bed_count': '0',
                'price': element.total_price, 'flag': element.flag, 'key': 'group_id', 'room_type_id': '0', 'comment': '',
                'visa_price': '0', 'food_price': '0'
              });

              if (element.arrival_date != '')
                values[values.length -1]['trip_arrival_date'] = element.arrival_date;

              break;
            }
          }
        }
      }
    });

    if (Number(this.data_model['ext_amount']) > 0) {

      item_discount = 0;
      if (discount > 0) {
        if (Number(this.data_model['ext_amount']) >= discount)
          item_discount = discount;
        else 
          item_discount = Number(this.data_model['ext_amount']);

        discount -= item_discount;
      }
      
      values.push({
        'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
        'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
        'sub_item_name': (this.data_model['amount_comment'] == '' ? this.Additional_Amount : this.data_model['amount_comment']),
        'price': Number(this.data_model['ext_amount']).toFixed(2), 'unit_id': '0', 'count': '1',
        'total_price': Number(this.data_model['ext_amount']).toFixed(2), 'tax_no': "0", 
        'invoice_item_id': '0', 'tax_amount': '0', 'type': 'fa', 'flag': 'new', 'key': 'invoice_item_id',
        'discount': item_discount, 'stock_no': '0', 'store_id': this.invoice_model['store_id'],
        'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '',
        'revenue_acct_no': this.revenue_acct_no
      });
    }

    //------------------------ Payment Method ------------------------//

    values.push({
      'table_name': 'inv_payment_method', 'invoice_no': this.invoice_model['invoice_no'],
      'inv_payment_method_id': this.inv_payment_model['inv_payment_method_id'], 'flag': this.inv_payment_model['flag'],
      'key': 'inv_payment_method_id', 'payment_type_id': '2', 'acct_number': this.invoice_model['customer_no'],
      'amount': this.data_model['final_total']
    });

    
    //------------------------ Ticket ------------------------//
    values.push({
      'table_name': 'reg_on_ticket', 'reg_ticket_id': this.ticket_model['reg_ticket_id'], 
      'ticket_type': this.ticket_model['ticket_type'], 'invoice_no': this.invoice_model['invoice_no'],
      'depart_flight_id': this.selectedDepartFlight['flight_id'], 
      'return_flight_id': (this.ticket_model['ticket_type'] == 'return' ? this.selectedReturnFlight['flight_id'] : '0'), 
      'depart_date': this.request_list[0]['depart_date'], 
      'flag': this.ticket_model['flag'], 'key': 'reg_ticket_id', 'from_airport': this.ticket_model['from_airport'],
      'to_airport': this.ticket_model['to_airport'], 'airline_id': this.ticket_model['airline_id'], 
      'comment': this.ticket_model['comment'], 'adult_count': adultCount, 'child_count': childCount, 
      'infant_count': infantCount, 'adult_price': adult_price, 'child_price': child_price,
      'infant_price': infant_price, 'adult_cost': '0', 'child_cost': '0', 'infant_cost': '0',
      'adult_discount': this.ticket_model['adult_discount'], 'child_discount': this.ticket_model['child_discount'], 
      'infant_discount': this.ticket_model['infant_discount'], 'tax_type': '', 'tax_no': '0', 
      'adult_tax_amount': '0', 'child_tax_amount': '0', 'infant_tax_amount': '0', 'adult_part_price': '0', 
      'child_part_price': '0', 'infant_part_price': '0'
    });

    if (this.request_list[0]['arrival_date'] != '')
      values[values.length -1]['return_date'] = this.request_list[0]['arrival_date'];

    console.log(values);
    let obj;

    if (this.invoice_model['invoice_id'] == '0') {
      let year = new Date().getFullYear();
      this.invoice_model['year'] = String(year);

      let idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
        this.applicationConstants.user_branch_info.user_branch_id + "'";
      let prefix = this.applicationConstants.user_branch_info.user_branch_id + '-' + year + '-';

      obj = {
        cmd: 'add', values: values, pk: 'invoice_no', id: 'no', main_table: 'invoice',
        prefix: prefix, idWhere: idWhere
      };
    }
    else
      obj = { cmd: 'updateAdv', values: values };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {

          if (this.invoice_model['invoice_id'] == '0') 
            this.invoice_model['invoice_no'] = data.status['msg'][0]['number'];

          // check if it is new invoice OR updated one and has no cash receipt OR 
          // updated one and has cash receipt and the invoice total has changed and 
          // there is cash receipt for this invoice, then link or fix the cash receipt
          // if (this.model['has_cash_receipt'] == 0 || 
          //   (this.model['has_cash_receipt'] == 1 && this.model['old_total_amount'] != Number(this.model['total_w_tax']))) {

          //   obj = {
          //     cmd: 'updateCashReceipt', invoice_no: this.invoice_model['invoice_no'],
          //     user_name: this.applicationConstants.user_info['user_name']
          //   };

          //   this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
          //     .subscribe(data => {
          //       this.applicationConstants.appComp.hideBusyCursor();

          //       if (data.status['type'] == 'error')
          //         alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);
                
          //       alert(this.Success_Msg + this.Inv_No_Msg + this.invoice_model['invoice_no']);
          //       this.router.navigate(['sub_menu/13/tour_invoice_list']);
                
          //     });
          // }
          // else {
            alert(this.Success_Msg + this.Inv_No_Msg + this.invoice_model['invoice_no']);
            window.open(this.applicationConstants.contractPrint + "?invoice_no=" + this.invoice_model['invoice_no'] + 
              "&lang=" + this.applicationConstants.user_lang, "_blank");
            this.router.navigate(['sub_menu/13/tour_invoice_list']);
          // }
        }
        else {
          alert(this.Error_Msg);
          this.saveClicked = false;
        }
      });
  }

  saveAgentInvoice() {
    let values = [];
    
    let invoice_date = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" +
      new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' +
      new Date().getSeconds();

    this.invoice_model['invoice_date'] = invoice_date;

    if (this.invoice_model['invoice_id'] == '0') {
      let invoice_uuid = uuidv4();
      this.invoice_model['invoice_uuid'] = invoice_uuid;

      this.invoice_model['deliver_date'] = this.invoice_model['invoice_date'];
      this.invoice_model['payment_date'] = this.invoice_model['invoice_date'];
    }

    this.invoice_model['payment_method'] = 'credit';
    this.invoice_model['sales_acct'] = this.revenue_acct_no;
    this.invoice_model['total'] = (Number(this.invoice_model['total']) + Number(this.data_model['ext_amount'])).toFixed(2);
    // this.invoice_model['discount'] = this.model['total_discount'];
    this.invoice_model['tax'] = '0';
    this.invoice_model['total_no_tax'] = '0';
    this.invoice_model['pass_count'] = this.data_model['ticket_num'];
    this.invoice_model['flight_id'] = this.selectedDepartFlight['flight_id'];
    this.invoice_model['invoice_type'] = "flight_block";
    this.invoice_model['agent_acct_number'] = this.request_list[0]['acct_number'];

    values.push(this.invoice_model);

    //------------------------ Invoice Item ------------------------//
    let item_discount = 0;
    let discount = Number(this.invoice_model['discount']);

    if (discount > 0) {
      if (Number(this.request_list[0].total_price) >= discount)
        item_discount = discount;
      else 
        item_discount = Number(this.request_list[0].total_price);

      discount -= item_discount;
    }

    values.push({
      'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
      'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
      'sub_item_name': this.Block_Sub_Item + " (" + this.data_model['ticket_num'] + " " + 
        this.Ticket_Sub_Item + ") - " + this.request_list[0].customer_name_en + " " + this.request_list[0].customer_last_name,
      'price': this.request_list[0].block_price, 'unit_id': '0', 'count': this.data_model['ticket_num'],
      'total_price': this.request_list[0].total_price, 'tax_no': "0", 'invoice_item_id': '0', 'tax_amount': '0',
      'type': 'f', 'flag': 'new', 'key': 'invoice_item_id',
      'discount': item_discount, 'stock_no': '0', 'store_id': this.invoice_model['store_id'],
      'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '',
      'revenue_acct_no': this.revenue_acct_no
    });

    if (Number(this.data_model['ext_amount']) > 0) {

      item_discount = 0;
      if (discount > 0) {
        if (Number(this.data_model['ext_amount']) >= discount)
          item_discount = discount;
        else 
          item_discount = Number(this.data_model['ext_amount']);

        discount -= item_discount;
      }
      
      values.push({
        'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
        'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
        'sub_item_name': (this.data_model['amount_comment'] == '' ? this.Additional_Amount : this.data_model['amount_comment']),
        'price': Number(this.data_model['ext_amount']).toFixed(2), 'unit_id': '0', 'count': '1',
        'total_price': Number(this.data_model['ext_amount']).toFixed(2), 'tax_no': "0", 
        'invoice_item_id': '0', 'tax_amount': '0', 'type': 'fa', 'flag': 'new', 'key': 'invoice_item_id',
        'discount': item_discount, 'stock_no': '0', 'store_id': this.invoice_model['store_id'],
        'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '',
        'revenue_acct_no': this.revenue_acct_no
      });
    }

    //------------------------ Payment Method ------------------------//

    values.push({
      'table_name': 'inv_payment_method', 'invoice_no': this.invoice_model['invoice_no'],
      'inv_payment_method_id': this.inv_payment_model['inv_payment_method_id'], 'flag': this.inv_payment_model['flag'],
      'key': 'inv_payment_method_id', 'payment_type_id': '2', 'acct_number': this.invoice_model['customer_no'],
      'amount': this.data_model['final_total']
    });


    //------------------------ Trip Group ------------------------//

    values.push({
      'table_name': 'trip_group', 'group_id': this.group_model['group_id'], 
      'invoice_no': this.invoice_model['invoice_no'],
      'head_id': this.request_list[0]['acct_number'], 'member_id': this.request_list[0]['acct_number'],
      'member_head_relation': 'رئيس المجموعة', 'is_active': '1', 'group_type': '',
      'trip_depart_date': this.selectedDepartFlight['flight_date'], 'eticket': '',
      'ticket_status': '0', 'ticket_count': '0', 'bed_count': '0',
      'price': this.request_list[0].total_price, 'flag': this.group_model['flag'], 
      'key': 'group_id', 'room_type_id': '0', 'comment': '',
      'visa_price': '0', 'food_price': '0'
    });

    if (this.ticket_model['ticket_type'] == 'return')
      values[values.length -1]['trip_arrival_date'] = this.selectedReturnFlight['flight_date'];

    //------------------------ Ticket ------------------------//

    values.push({
      'table_name': 'reg_on_ticket', 'reg_ticket_id': this.ticket_model['reg_ticket_id'], 
      'ticket_type': this.ticket_model['ticket_type'], 'invoice_no': this.invoice_model['invoice_no'],
      'depart_flight_id': this.selectedDepartFlight['flight_id'], 
      'return_flight_id': (this.ticket_model['ticket_type'] == 'return' ? this.selectedReturnFlight['flight_id'] : '0'), 
      'depart_date': this.selectedDepartFlight['flight_date'], 
      'flag': this.ticket_model['flag'], 'key': 'reg_ticket_id', 'from_airport': this.ticket_model['from_airport'],
      'to_airport': this.ticket_model['to_airport'], 'airline_id': this.ticket_model['airline_id'], 
      'comment': this.ticket_model['comment'], 'adult_count': this.data_model['ticket_num'], 'child_count': '0', 
      'infant_count': '0', 'adult_price': this.request_list[0].block_price, 'child_price': '0',
      'infant_price': '0', 'adult_cost': '0', 'child_cost': '0', 'infant_cost': '0',
      'adult_discount': this.ticket_model['adult_discount'], 'child_discount': this.ticket_model['child_discount'], 
      'infant_discount': this.ticket_model['infant_discount'], 'tax_type': '', 'tax_no': '0', 
      'adult_tax_amount': '0', 'child_tax_amount': '0', 'infant_tax_amount': '0', 'adult_part_price': '0', 
      'child_part_price': '0', 'infant_part_price': '0'
    });

    if (this.ticket_model['ticket_type'] == 'return')
      values[values.length -1]['return_date'] = this.selectedReturnFlight['flight_date'];

    //------------------------ Flight Block ------------------------//

    values.push({
      'table_name': 'flight_block', 'flight_block_id': this.block_model['flight_block_id'], 
      'invoice_no': this.invoice_model['invoice_no'], 'agent_no': this.request_list[0]['acct_number'],
      'ticket_type': this.ticket_model['ticket_type'], 'depart_flight_id': this.selectedDepartFlight['flight_id'], 
      'return_flight_id': (this.ticket_model['ticket_type'] == 'return' ? this.selectedReturnFlight['flight_id'] : '0'), 
      'block_num': this.data_model['ticket_num'], 'flag': this.ticket_model['flag'], 
      'key': 'flight_block_id', 'block_price': this.request_list[0].block_price
    });

    console.log(values);
    let obj;

    if (this.invoice_model['invoice_id'] == '0') {
      let year = this.data_model['invoice_date'].getFullYear();
      this.invoice_model['year'] = String(year);

      let idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
        this.applicationConstants.user_branch_info.user_branch_id + "'";
      let prefix = this.applicationConstants.user_branch_info.user_branch_id + '-' + year + '-';

      obj = {
        cmd: 'add', values: values, pk: 'invoice_no', id: 'no', main_table: 'invoice',
        prefix: prefix, idWhere: idWhere
      };
    }
    else
      obj = { cmd: 'updateAdv', values: values };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {

          if (this.invoice_model['invoice_id'] == '0') 
            this.invoice_model['invoice_no'] = data.status['msg'][0]['number'];

          alert(this.Success_Msg + this.Inv_No_Msg + this.invoice_model['invoice_no']);
            this.router.navigate(['sub_menu/13/tour_invoice_list']);
        }
        else {
          alert(this.Error_Msg);
          this.saveClicked = false;
        }
      });
  }
}
